import { v4 as uuidv4 } from 'uuid';

/**
 * A logical submission is one company, verified once, in one session/journey.
 * A new lookup returns a new reference, so it is a new logical submission.
 */
export const submissionIdentity = (scope: string, cui: string, verificationReference: string): string =>
    JSON.stringify([scope, cui, verificationReference]);

export interface IdempotencyKeyStore {
    /** The key of this logical submission; generated on the first request for it. */
    keyFor(identity: string): string;
}

/**
 * Keeps only the latest key, in memory (never in local storage). The same
 * identity always gets the same key, so a retry of an uncertain submit can be
 * recognised by the server; any other identity gets a new one.
 */
export const newIdempotencyKey = (): string => uuidv4();

export const createIdempotencyKeyStore = (generate: () => string = newIdempotencyKey): IdempotencyKeyStore => {
    let current: { identity: string; key: string } | null = null;
    return {
        keyFor: (identity) => {
            if (current === null || current.identity !== identity) {
                current = { identity, key: generate() };
            }
            return current.key;
        },
    };
};
